<template>
  <div>
    <el-popover placement="bottom" trigger="click" v-model="popShow">
      <el-table
        :data="prices"
        size="mini"
        :header-cell-style="{background:'#D7D7D7',color:'#000'}"
        :row-style="{height:'30px'}"
        @row-click="handleSelect"
        :cell-class-name="ocopRowZebraStyle"
      >
        <el-table-column width="90" property="type" label="Type" ></el-table-column>
        <el-table-column width="80" property="price" label="Price" align="right" ></el-table-column>
        <div slot="empty"><span class="price-popover-table-empty-text">No Data</span></div>
      </el-table>
      <!-- <el-button size="mini" round :style="{color: '#409EFF'}" slot="reference">SEE</el-button> -->
      <el-button size="mini" type="text" plain icon="el-icon-s-unfold" circle slot="reference" style="font-size: 16px" ></el-button>
    </el-popover>
    <slot />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ColumnPriceDropDown',
  props: {
    rowId: {
      type: [String, Number],
      required: true
    },
    clickable: {
      type: Boolean,
      default: false
    }
  },
  created () {
    // David要求取消COST价格的显示
    // 后来刘老师又要求继续显示COST价格
    // this.prices = this.filterCostPrice(this.product(this.rowId).prices)
    this.prices = this.product(this.rowId).prices
    this.bus.$on(`product-selected-${this.rowId}`, (product) => {
      // this.prices = this.filterCostPrice(product.prices)
      this.prices = product.prices
    })
  },
  beforeDestroy () {
    this.bus.$off(`product-selected-${this.rowId}`)
  },
  data () {
    return {
      popShow: false,
      prices: []
    }
  },
  computed: {
    ...mapGetters({
      product: 'edit/lineProduct'
    })

  },
  methods: {
    filterCostPrice (arr) {
      let newP = []
      if (arr.length > 0) {
        arr.map((i) => {
          if (!i.type.toLowerCase().includes('cost')) newP.push(i)
        })
        return newP
      } else return []
    },
    handleSelect (row) {
      if (this.clickable) {
        if (this.tValue !== row.price) {
          this.tValue = row.price
          this.priceChange(row.price)
        }
        this.popShow = false
      }
    },
    priceChange (val) {
      this.bus.$emit(`line-price-selected-${this.rowId}`, val)
    },
    ocopRowZebraStyle ({ row }) {
      switch (row.type) {
        case 'Standard':
          return 'table-column-sale-type-color'
        case 'Special':
          return 'table-column-sale-type-color'
        case 'Class A':
          return 'table-column-class-type-color'
        case 'Class B':
          return 'table-column-class-type-color'
        case 'OCOP':
          return 'table-column-ocop-type-color'
        case 'Cost Price':
          return 'table-column-cost-type-color'
        case 'Cost USD':
          return 'table-column-cost-type-color'
      }
    }
  },
  inject: ['bus']
}
</script>

<style lang="scss" scoped>
.price-popover-table-empty-text {
  display: inline-block;
  font-size: 18px;
  font-weight: bold;
  margin: 15px 0;
  color: rgba(225, 225, 225, 0.55)
}
</style>
